module.exports = __webpack_public_path__ + "img/GQ.d6b2b920.png";